var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"clearfix mb-0 position-absolute"})
}
var staticRenderFns = []

export { render, staticRenderFns }